// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@west/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartTotalDisplayStyles } from "@west/Overrides/Components/CartTotalDisplay";
import { hideElementOnPrint, mergeWithCss } from "@west/XDL/Utilities";
import { css } from "styled-components";

cartTotalDisplayStyles.container = {
    gap: 8,
    css: css`
        padding: 0;
    `,
};

cartTotalDisplayStyles.fullWidthGridItem = {
    width: 12,
};

cartTotalDisplayStyles.promotionGridItem = {
    width: 12,
    css: hideElementOnPrint,
};

cartTotalDisplayStyles.orderSummaryLabel = {
    ...orderTotalDisplaySharedStyles.titleText,
};

cartTotalDisplayStyles.promotionLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.discountsLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.shippingAndHandlingLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.subShippingAndHandlingLabel = {
    size: 12,
    weight: "normal",
    css: css`
        letter-spacing: 0;
        line-height: 16px;
    `,
};

cartTotalDisplayStyles.otherChargesLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.taxLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.totalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};

cartTotalDisplayStyles.labelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};

cartTotalDisplayStyles.labelContainer = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

cartTotalDisplayStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.styledHr = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.styledHr, {
        css: hideElementOnPrint,
    }),
};

cartTotalDisplayStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.totalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
};

cartTotalDisplayStyles.valueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};

cartTotalDisplayStyles.promotionValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.shippingAndHandlingValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.taxValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.discountsValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.shippingAndHandlingWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
    `,
};

cartTotalDisplayStyles.shippingAndHandlingTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 7px;
        `,
    },
};

cartTotalDisplayStyles.shippingAndHandlingIcon = {
    size: 12,
    color: "common.ui8",
};
